// components/PhoneLink.jsx
import React from "react";
import { Phone } from "lucide-react";
import apiService from "../services/api";
import { useTheme } from "../contexts/ThemeContext";

const PhoneLink = ({
  phoneNumber,
  entityType,
  entityId,
  entityName,
  className = "",
}) => {
  const { isDarkMode } = useTheme();

  const handlePhoneClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      // Create call note
      await apiService.createCallNote({
        phoneNumber,
        entityType,
        entityId,
        entityName,
      });

      // Open dialer
      window.location.href = `tel:${phoneNumber}`;
    } catch (error) {
      console.error("Error creating call note:", error);
      // Still allow the call to go through even if note creation fails
      window.location.href = `tel:${phoneNumber}`;
    }
  };

  if (!phoneNumber) return null;

  return (
    <a
      href={`tel:${phoneNumber}`}
      onClick={handlePhoneClick}
      className={`flex items-center gap-2 transition-colors ${className} ${
        isDarkMode
          ? "text-blue-400 hover:text-blue-300"
          : "text-blue-600 hover:text-blue-700"
      }`}
    >
      <Phone size={16} />
      <span>{phoneNumber}</span>
    </a>
  );
};

export default PhoneLink;
